import { render, staticRenderFns } from "./MediaPostPriceSettings.vue?vue&type=template&id=92924194&scoped=true&"
import script from "./MediaPostPriceSettings.vue?vue&type=script&lang=ts&"
export * from "./MediaPostPriceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92924194",
  null
  
)

export default component.exports